import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M20.0002 36.0896L10.5771 26.6665L12.0942 25.1495L20.0002 33.0234L27.9062 25.1495L29.4232 26.6665L20.0002 36.0896ZM12.1027 14.8417L10.5771 13.3332L20.0002 3.91016L29.4232 13.3332L27.8976 14.8417L20.0002 6.97632L12.1027 14.8417Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map